import React from "react";
import "./Months.css";

const NextMonth = () => {
  const month = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  var now = new Date();
  if (now.getMonth() === 11) {
    var current = new Date(now.getFullYear() + 1, 0, 1);
  } else {
    current = new Date(now.getFullYear(), now.getMonth() + 1, 1);
  }
  let name = month[current.getMonth()];

  return (
    <div className="thisMonth">
      <span className="month">{name + " - " + current.getFullYear()}</span>
    </div>
  );
};

export default NextMonth;
